import React, { Component } from 'react';
import './style.css';

import State from '../State'

class Introduction extends Component {

  handleGetStartedClick() {
    State.action('getStarted')
  }

  render() {
    let classes = 'introduction' + (State.ui.intro ? ' active' : '')

    return (
      <div className={classes}>
        <div className="centered"><h2>Moisture balance calculator</h2></div>
        <img src="img/intro1.jpg" alt="Illustration of person in a house balanced on a see saw"/>
        <div className="description">
          <div>You need a balanced amount of moisture to maintain a healthy home. This means having a building which is not too dry and not too humid. Keeping your home in balance can be tricky as there are a lot factors to think about such as the moisture you generate in cooking, washing and so on, and your heating, ventilation and maintenance.</div>
          <div>Using this tool should give you a better understanding of the moisture balance in your home and the factors at play. If your home is out of balance, you might be able to identify easy ways to regain moisture balance and create a healthier home.</div>
        </div>
        <div className="centered button" onClick={this.handleGetStartedClick}>Get started</div>
      </div>
    );
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/Introduction/index.js